<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card style="background:white;width:100%;margin:0%;padding:0%;">
            <production-analisys-promocional-chart></production-analisys-promocional-chart>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card style="background:white;width:100%;margin:0%;padding:0%;">
            <production-analisys-promocional-chart-bar></production-analisys-promocional-chart-bar>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card style="background:white;width:100%;margin:0%;padding:0%;">
            <!-- <amount-attention-sale-month-chart></amount-attention-sale-month-chart> -->
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ProductionAnalisysPromocionalChart from "../../../components/dashboard/sale-promocional/ProductionAnalisysPromocionalChart";
import ProductionAnalisysPromocionalChartBar from "../../../components/dashboard/sale-promocional/ProductionAnalisysPromocionalChartBar";
// import AmountAttentionSaleMonthChart from "../../../components/dashboard/sale-promocional/AmountAttentionSaleMonthChart";

export default {
  name: "DashboardAnalisys",
  components: {
    OfficeLogin,
    ProductionAnalisysPromocionalChart,
    ProductionAnalisysPromocionalChartBar,
    // AmountAttentionSaleMonthChart,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Dashboard",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  computed: {
    ...mapState("dashboard", []),
  },
  methods: {
    ...mapActions("dashboard", []),
  },
  created() {},
};
</script>

<style scoped></style>
